import { render, staticRenderFns } from "./NumberOneSVG.vue?vue&type=template&id=5b86762a&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b86762a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b86762a')) {
      api.createRecord('5b86762a', component.options)
    } else {
      api.reload('5b86762a', component.options)
    }
    module.hot.accept("./NumberOneSVG.vue?vue&type=template&id=5b86762a&scoped=true&", function () {
      api.rerender('5b86762a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/NumberOneSVG.vue"
export default component.exports